import {
  integration as mailChimpIntegration,
  key as mailChimpKey,
} from '../../integrations/mail-chimp/manifest';
import {
  integration as facebookCatalogIntegration,
  key as facebookCatalogKey,
} from '../../integrations/facebook-catalog/manifest';
import {
  integration as googleAnalyticsIntegration,
  key as googleAnalyticsKey,
} from '../../integrations/google-analytics/manifest';
import {
  integration as facebookPixelIntegration,
  key as facebookPixelKey,
} from '../../integrations/facebook-pixel/manifest';
import {
  integration as googleTagManagerIntegration,
  key as googleTagManagerKey,
} from '../../integrations/google-tag-manager/manifest';
import {
  integration as hotjarIntegration,
  key as hotjarKey,
} from '../../integrations/hotjar/manifest';
import {
  integration as wisepopsIntegration,
  key as wisepopsKey,
} from '../../integrations/wisepops/manifest';
import {
  integration as privyIntegration,
  key as privyKey,
} from '../../integrations/privy/manifest';
import {
  integration as helloBarIntegration,
  key as helloBarKey,
} from '../../integrations/hello-bar/manifest';
import {
  integration as wixAnalyticsIntegration,
  key as wixAnalyticsKey,
} from '../../integrations/wix-analytics/manifest';
import {
  integration as yandexMetricaIntegration,
  key as yandexMetricaKey,
} from '../../integrations/yandexMetrica/manifest';
import {
  integration as googleAdWordsIntegration,
  key as googleAdWordsKey,
} from '../../integrations/google-adwords/manifest';
import {
  integration as gtagIntegration,
  key as gtagKey,
} from '../../integrations/gtag/manifest';
import {
  integration as vwoIntegration,
  key as vwoKey,
} from '../../integrations/vwo/manifest';
import {
  integration as callRailIntegration,
  key as callRailKey,
} from '../../integrations/callRail/manifest';
import {
  integration as vkRetargetingIntegration,
  key as vkRetargetingKey,
} from '../../integrations/vkRetargeting/manifest';
import {
  integration as crazyEggIntegration,
  key as crazyEggKey,
} from '../../integrations/crazyEgg/manifest';
import {
  integration as hubspotIntegration,
  key as hubspotKey,
} from '../../integrations/hubspot/manifest';

export const integrationsManifests = {
  [mailChimpKey]: mailChimpIntegration,
  [facebookCatalogKey]: facebookCatalogIntegration,
  [googleAnalyticsKey]: googleAnalyticsIntegration,
  [facebookPixelKey]: facebookPixelIntegration,
  [googleTagManagerKey]: googleTagManagerIntegration,
  [hotjarKey]: hotjarIntegration,
  [wisepopsKey]: wisepopsIntegration,
  [privyKey]: privyIntegration,
  [helloBarKey]: helloBarIntegration,
  [wixAnalyticsKey]: wixAnalyticsIntegration,
  [yandexMetricaKey]: yandexMetricaIntegration,
  [googleAdWordsKey]: googleAdWordsIntegration,
  [gtagKey]: gtagIntegration,
  [vwoKey]: vwoIntegration,
  [crazyEggKey]: crazyEggIntegration,
  [callRailKey]: callRailIntegration,
  [vkRetargetingKey]: vkRetargetingIntegration,
  [hubspotKey]: hubspotIntegration,
};
